import React from "react";
import { makeStyles } from '@mui/styles';
import { motion } from "framer-motion";
import { Box, Link } from '@mui/material';

const IconBtn = ({ icon: Icon, href, fontSize, ...rest }) => {
  const classes = useStyles({ fontSize });
  return (
    <Box
      display="inline"
      {...rest}
      component={motion.div}
      whileHover={{ scale: 1.1 }}
    >
      <Link href={href}>
        <Icon className={classes.icon} />
      </Link>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  icon: {
    // color: theme.palette.text.secondary,
    color: '#FFF',
    transition: "0.1s",
    cursor: "pointer",
    fontSize: props => props.fontSize ? `${props.fontSize}px` : "32px",
    "&:hover": {
      color: theme.palette.text.primary
    }
  },
}));

export default IconBtn;
